import { Children, forwardRef, isValidElement } from 'react';
import { RootComponent } from '../../../../services/root-component';
import type { OptionProps, LayoutProps } from '../../types';
import { Indicator } from '../indicator';
import css from './style.module.css';

export const Entry = forwardRef<HTMLDivElement, LayoutProps>(function Component(
  {
    Component = 'nav',
    className,
    style,
    children,
    role = 'radiogroup',
    ...listProps
  },
  forwardedRef
) {
  const childrenList = Children.toArray(children);
  const selectedElementIndex = childrenList.findIndex(
    (element) => isValidElement<OptionProps>(element) && element.props.checked
  );

  return (
    <RootComponent
      Component={Component}
      baseClassName={css.root}
      className={className}
      style={style}
      ref={forwardedRef}
    >
      <div className={css.inner}>
        <Indicator
          target={selectedElementIndex}
          count={Children.count(children)}
        />

        <div {...listProps} className={css.list} role={role}>
          {children}
        </div>
      </div>
    </RootComponent>
  );
});
